module.exports = __webpack_public_path__ + "img/icon-desktop.a6821210.svg";